/**
* @file 业务设置-排班管理-查看/编辑排班
* */
<template>
  <div id="schedulingForm">
    <!-- 设置票价模态框 -->
    <el-dialog title="线路票价" class="setmoney" :visible.sync="dialogVisible" width="360px" :close-on-click-modal="false">
      <el-input placeholder="这条路线的售票票价" maxlength="3"
        @input="input2 = input2.replace(/[^\d]/g, '').replace(/^0{1,}/g, '')" v-model="input2" prop="region">
        <template slot="append">元</template>
      </el-input>
      <div class="motoal">
        <el-button type="primary" size="mini" @click="feeSave">保存</el-button>
      </div>
    </el-dialog>

    <!-- 点击列表查看座位 -->
    <el-dialog title="座位详情" :visible.sync="dialogVisible2" width="400px" class="LookSeat">
      <div class="seat-top">
        <div class="seat-top-left">
          <span class="seat-top-span1"> </span>可选
        </div>
        <div class="seat-top-right">
          <span class="seat-top-span2"> </span>已购
        </div>
      </div>

      <div class="seat-content">
        <div class="driver">
          <div class="drivers"></div>
          司机
        </div>

        <div class="seat-content-center" :class="Accordinsg.length == 4
          ? 'passe1'
          : Accordinsg.length == 6
            ? 'passe2'
            : Accordinsg.length == 7
              ? 'passe3'
              : Accordinsg.length == 8
                ? 'passe4'
                : ''
          " v-for="(item, index) in Accordinsg" :key="index">
          <div v-if="item.isSoldTicket == 1" class="content-center">
            <img style="width: 100%; height: 100%" src="../../../assets/img/kexuan1.png" alt="" />
            <span class="seat-details">{{ item.seatNo }}</span>
          </div>
          <div v-if="item.isSoldTicket == 2" class="content-center">
            <img style="width: 100%; height: 100%" src="../../../assets/img/yixuan1.png" alt="" />
            <span class="seat-details1">{{ item.seatNo }}</span>
          </div>
          <p>¥{{ item.fee }}</p>
        </div>
      </div>
      <div class="motoal">
        <el-button type="primary" @click="dialogVisible2 = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 查看线路票价模态框 -->
    <el-dialog class="semoney" :visible.sync="dialogVisible3" width="40%">
      <div class="updatePrice">
        <span class="detail">{{ detailTitle }}</span>
        <span class="update" v-if="!showEdit" @click="handleEdit">{{
          info.railType == 2 && info.schedulingType == 3
          ? "修改价格"
          : "修改票价"
        }}</span>
      </div>
      <el-form ref="priceForm" :model="priceForm" style="margin: 0 auto">
        <el-table :data="priceForm.stationRailFee" border max-height="250" style="width: 100%">
          <el-table-column prop="startRailName" label="出发地">
          </el-table-column>
          <el-table-column prop="endRailName" label="目的地"> </el-table-column>
          <el-table-column prop="fee" width="180" :label="'票价'">
            <template slot-scope="scope">
              <el-form-item :prop="'stationRailFee.' + scope.$index + '.fee'" :rules="{
                required: true,
                message: '请设置票价',
                trigger: 'blur',
              }">
                <div v-if="showEdit" style="display: flex; padding-right: 2px">
                  <el-input v-model="scope.row.fee" maxlength="3"
                    @input="scope.row.fee = scope.row.fee.replace(/[^\d]/g, '').replace(/^0/g, '')"
                    style="margin: 0; width: 150px; cursor: pointer">
                    <template slot="prepend">￥</template>
                    <template slot="append"></template>
                  </el-input>
                </div>
              </el-form-item>

              <span v-if="!showEdit">￥{{ scope.row.fee }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div class="submit">
        <el-button type="primary" @click="feeClick" v-if="showEdit">保存</el-button>
      </div>
    </el-dialog>

    <template v-if="info.schedulingType === null">
      <div class="schedulingFormTop">
        <div class="line-info schedulingFormTopItem"
          :class="info.schedulingType === 2 ? '' : 'schedulingFormTopItemLine'">
          <img class="icon-line" src="../../../assets/img/line.png" alt="" />
          <span style="font-weight: 600">{{ info.startStationName }} - {{ info.endStationName }}</span>

          <div style="display: flex; height: 28px; margin: 0 30px">
            <span v-if="info.schedulingType == 1 ||
              info.schedulingType == 2 ||
              info.schedulingType == 3
              ">{{ info.schedulingType | filterConst("SCHELINGTYPE") }}
            </span>
          </div>

          <div v-if="info.railType !== 2 &&
            (info.schedulingType === 1 || info.schedulingType == 2)
            ">
            票价:<span style="color: rgb(255, 153, 0)">{{
              info.fee == null ? "待设置" : "¥" + info.fee
            }}</span>
          </div>
        </div>

        <div class="schedulingFormTopItem line-info" v-if="info.schedulingType === 2">
          <span>值班车辆</span>
          <span class="util-remark">本线路订单将按派单顺序，自动派出</span>
        </div>
      </div>
      <p class="type-title">请选择要创建的排班模式：</p>
      <div @click="postSchedulingType(item.value)" style="cursor: pointer" class="type-item"
        v-for="item in $const.SCHELINGTYPE" :key="item.value">
        <p>{{ item.label }}</p>
        <p class="des">{{ item.des }}</p>
        <img src="../../../assets/img/right.png" alt="" />
      </div>
    </template>

    <el-tabs v-else type="card" v-model="tabAction">
      <el-tab-pane label="平台创建" name="platform">
        <div class="schedulingFormTop">
          <div class="line-info schedulingFormTopItem" :class="info.schedulingType === 2 ? '' : 'schedulingFormTopItemLine'
            ">
            <img class="icon-line" src="../../../assets/img/line.png" alt="" />
            <span style="font-weight: 600">{{ info.startStationName }} - {{ info.endStationName }}</span>

            <div style="display: flex; height: 28px; margin: 0 30px">
              <span v-if="info.schedulingType == 1 ||
                info.schedulingType == 3 ||
                info.schedulingType == 2
                ">{{ info.schedulingType | filterConst("SCHELINGTYPE") }}
              </span>
            </div>

            <div v-if="info.railType !== 2 &&
              (info.schedulingType === 1 || info.schedulingType == 2)
              ">
              票价:<span style="color: rgb(255, 153, 0)">{{
                info.fee == null ? "待设置" : "¥" + info.fee
              }}</span>
            </div>
          </div>

          <div class="schedulingFormTopItem line-info" v-if="info.schedulingType === 2">
            <span style="font-weight: 600">
              {{ getWeek(schedulingJson[dateActiveIndex].schedulingTime) }}
              {{
                schedulingJson[dateActiveIndex].schedulingTime
                | filterTime("MM-DD")
              }}
              值班车辆
            </span>
            <span class="util-remark">当天的订单将按派单顺序，自动派出</span>
          </div>
        </div>

        <!-- 班次列表 -->
        <template v-if="info.schedulingType === 1 ||
            info.schedulingType === 2 ||
            info.schedulingType === 3
            ">
          <el-form :model="form" ref="form" label-width="0">
            <div class="sF-item" :class="info.schedulingType === 2 ? '' : 'sF-item-line'">
              <div class="sF-cont">
                <div class="scheduling-form-date">
                  <div class="left">
                    <custom-across-roll ref="customAcrossRoll">
                      <div v-for="(scheduling, i) in schedulingJson" :key="i" class="date"
                        :class="dateActiveIndex === i ? 'active' : ''" @click="dateClick(scheduling, i)"
                        :style="{ background: newCopy == scheduling.schedulingTime ? '#F2F2F2' : '' }"
                        @mouseover="dateHover('over', i)" @mouseout="dateHover('out', i)">
                        <span class="date-text">{{ getWeek(scheduling.schedulingTime) }}
                          {{
                            scheduling.schedulingTime | filterTime("MM-DD")
                          }}</span>
                        <span class="date-close" :class="type !== 'view' && scheduling.remove === 1
                              ? 'remove'
                              : ''
                            " @click.stop="removeClick(scheduling, i)">×</span>
                      </div>
                      <div class="date" @click="copyClick" v-if="type !== 'view'">
                        复制排班
                      </div>
                    </custom-across-roll>
                  </div>
                  <el-button v-if="type !== 'view' && schedulingJson.length < 30" @click="addDateClick">添加日期</el-button>
                </div>

                <div style="display: flex; align-items: center; margin: 20px 0">
                  <strong style="margin-right: 20px">状态：</strong>
                  <el-radio-group v-model="status" @change="statusChange" style="margin-right: 50px">
                    <el-radio :label="1">全部</el-radio>
                    <el-radio :label="2">停止售票</el-radio>
                    <el-radio :label="3">售票中</el-radio>
                  </el-radio-group>

                  <el-checkbox v-model="checked" @change="statusChange">只看有余票</el-checkbox>
                </div>

                <div class="util-remark" v-if="type !== 'view'">
                  注意：只有无人购票的班次，才能被编辑和删除
                </div>

                <div class="scheduling-form-table">
                  <table border class="table table_scheduling">
                    <tr>
                      <th class="th1">状态</th>
                      <th class="th2">
                        开始{{
                          info.lineType == 1 || info.lineType == 2
                          ? "检票"
                          : "接人"
                        }}
                      </th>
                      <th class="th3">预计发车</th>
                      <th class="th4" v-if="info.schedulingType === 1 || info.schedulingType === 3
                          ">
                        值班车辆
                      </th>
                      <th class="th5" v-if="info.schedulingType === 1 || info.schedulingType === 3
                        ">
                        可购票
                      </th>
                      <th class="th6" v-if="info.schedulingType === 2">
                        票数限制
                      </th>
                      <th class="th7">已购票</th>
                      <th class="th8">余票</th>
                      <th v-if="type === 'view'">是否启用</th>
                      <th class="th9" v-if="type !== 'view'">操作</th>
                    </tr>
                    <tr v-if="!form.shiftActive || form.shiftActive.length == 0">
                      <td colspan="9" style="text-align: center">暂无数据</td>
                    </tr>
                    <tr @click="According(item)" :class="item.soldTickets <= 0 ? '' : 'gray'"
                      v-for="(item, index) in form.shiftActive" :key="index">
                      <template v-if="item.operationType !== 3 && item.show">
                        <td class="th1" @click.stop>
                          <span v-if="item.status == 1 && item.isEnabled == 1">售票中</span>
                          <span v-if="item.status == 2 || item.isEnabled == 2">停止售票</span>
                        </td>
                        <td class="th2" @click.stop>
                          <span v-if="type === 'view'">{{
                            item.startTime
                          }}</span>
                          <el-form-item v-else :prop="'shiftActive.' + index + '.startTime'" :rules="[
                            { validator: validate, trigger: 'change' },
                          ]">
                            <el-time-picker :disabled="Number(item.soldTickets) > 0" v-model="item.startTime"
                              format="HH:mm" :default-value="form.shiftActive &&
                                form.shiftActive[index - 1] &&
                                form.shiftActive[index - 1].startTime
                                ? new Date(
                                  2000,
                                  1,
                                  1,
                                  form.shiftActive[
                                    index - 1
                                  ].startTime.split(':')[0],
                                  Number(
                                    form.shiftActive[
                                      index - 1
                                    ].startTime.split(':')[1]
                                  )
                                )
                                : new Date()
                                " value-format="HH:mm" @change="changeFn(index)"></el-time-picker>
                          </el-form-item>
                        </td>
                        <td class="th3" @click.stop>
                          <span v-if="type === 'view'">{{ item.endTime }}</span>
                          <el-form-item v-else :prop="'shiftActive.' + index + '.endTime'" :rules="[
                            { validator: validateEnd, trigger: 'change' },
                          ]">
                            <el-time-picker :disabled="Number(item.soldTickets) > 0" v-model="item.endTime" format="HH:mm"
                              :default-value="item.startTime
                                ? new Date(
                                  2000,
                                  1,
                                  1,
                                  item.startTime.split(':')[0],
                                  Number(item.startTime.split(':')[1])
                                )
                                : new Date()
                                " value-format="HH:mm" @change="changeFn(index)"></el-time-picker>
                          </el-form-item>
                        </td>
                        <td class="th4" @click.stop v-if="info.schedulingType === 1 ||
                          info.schedulingType === 3
                          ">
                          <template v-if="item.schedulingVehicleJson &&
                            item.schedulingVehicleJson.length > 0
                            ">
                            <p v-for="vehicleObj in item.schedulingVehicleJson" :key="vehicleObj.id">
                              <span :class="type == 'view' ? 'link' : ''">{{
                                vehicleObj.licenseNo
                              }}</span>
                              {{ vehicleObj.vehicleSeat }}座
                              {{ vehicleObj.driverName }}
                            </p>
                          </template>
                          <span v-else style="color: #999">待添加</span>
                        </td>
                        <td class="th5" @click.stop v-if="info.schedulingType === 1 ||
                          info.schedulingType === 3
                          ">
                          <span v-if="item.ticketNum">{{ item.ticketNum }}张</span>
                          <span v-else>-</span>
                        </td>
                        <td class="th6" v-if="info.schedulingType === 2" @click.stop>
                          <span v-if="type === 'view'">{{
                            item.ticketNumType === 1
                            ? "不限购"
                            : "限购：" + item.ticketNum + "张"
                          }}</span>
                          <el-form-item v-else :prop="'shiftActive.' + index + '.ticketNumType'" :rules="{
                            required: true,
                            message: '请选择票数限制',
                            trigger: 'blur',
                          }">
                            <el-radio-group v-model="item.ticketNumType" @change="changeFn(index, item)"
                              :disabled="Number(item.soldTickets) > 0">
                              <el-radio :label="1">不限购</el-radio>
                              <el-radio :label="2">限购</el-radio>
                              <el-form-item :prop="'shiftActive.' + index + '.ticketNum'" :rules="[
                                {
                                  required: Boolean(item.ticketNumType === 2),
                                  message: '请输入限购数量',
                                  trigger: 'blur',
                                },
                                {
                                  pattern: /^[1-9]\d{0,2}$/,
                                  message: '请输入数字',
                                },
                              ]">
                                <el-input class="ticket-num" v-model="item.ticketNum" :disabled="Number(item.soldTickets) > 0 ||
                                  (Number(item.soldTickets) <= 0 &&
                                    item.ticketNumType === 1)
                                  " @input="changeFn(index)" maxlength="3">
                                  <template slot="append">张</template>
                                </el-input>
                              </el-form-item>
                            </el-radio-group>
                          </el-form-item>
                        </td>
                        <td class="th7" @click.stop>
                          {{
                            item.soldTickets || item.soldTickets === 0
                            ? item.soldTickets
                            : "-"
                          }}
                        </td>
                        <td class="th8" @click.stop>
                          {{
                            item.remainingTickets
                            ? item.remainingTickets
                            : item.ticketNumType === 1
                              ? "-"
                              : item.compile
                                ? "-"
                                : 0
                          }}
                        </td>
                        <td class="th9" v-if="type !== 'view'" @click.stop>
                          <el-button v-if="Number(item.soldTickets) <= 0" @click="removeFn(item, index)" type="text">删除
                          </el-button>
                          <el-button type="text" @click="addClick(index)" v-if="item.status === 1 &&
                            lastListArr &&
                            lastListArr.length < 100
                            ">向上插班
                          </el-button>
                          <el-button type="text" v-if="Number(item.soldTickets) <= 0 &&
                            info.schedulingType === 1
                            " @click="editVehicle(item, index)">
                            编辑车辆
                          </el-button>

                          <el-button v-if="info.schedulingType === 3" type="text" @click="editVehicle(item, index)">
                            值班车辆
                          </el-button>
                        </td>
                        <td class="th10" v-if="type === 'view'" @click.stop>
                          <div class="custom-switch">
                            <el-switch v-model="item.isEnabled" :active-value="1" :inactive-value="2"
                              @change="switchClick($event, item)">
                            </el-switch>
                          </div>
                        </td>
                      </template>
                    </tr>
                  </table>
                </div>

                <!--如果日期为当天，或当前为查看页，或班次条数已经50条，则隐藏【添加班次】-->
                <div class="add" @click="addClick" v-if="lastListArr.length < 100 && type !== 'view'">
                  <i class="el-icon-plus"></i>添加班次
                </div>

                <el-button style="margin-top: 40px; width: 120px" type="success" @click="saveClick" v-if="type !== 'view'"
                  :loading="loading">
                  保 存
                </el-button>

                <el-button style="margin-top: 40px; width: 120px" plain v-if="type != 'view' &&
                  info.railType != 2 &&
                  (info.schedulingType === 1 || info.schedulingType == 2)
                  " @click="showMoatl">
                  修 改 票 价
                </el-button>

                <el-button style="margin-top: 40px; width: 120px" plain v-if="type == 'view'" 
                  @click="type = 'scheduling'">
                  编辑排班
                </el-button>

                <el-button style="margin-top: 40px; width: 120px" plain v-if="info.railType == 2" @click="showLine">
                  查看线路票价
                </el-button>

                <el-button style="margin-top: 40px; width: 120px" plain @click="reset" v-if="type !== 'view'">
                  模 式 重 置
                </el-button>
              </div>
            </div>

            <div class="sF-item" v-if="info.schedulingType === 2">
              <div class="sF-cont">
                <div class="scheduling-form-table">
                  <table border class="table table_vehicle">
                    <tr>
                      <th>派单顺序</th>
                      <th>车辆信息</th>
                      <th>值班司机</th>
                      <th v-if="type !== 'view'">操作</th>
                    </tr>
                    <tr v-for="(item, index) in getVehicles" :key="index">
                      <td>
                        {{ item.sort }}
                      </td>
                      <td>
                        <span v-if="item.licenseNo" :style="getPlateStyle(item.licenseNo)">{{ formatPlateNumber(item.licenseNo) }}</span>
                        <span v-else>-</span>
                        <span style="margin-left:4px;">{{ item.vehicleSeat }}座</span>
                      </td>
                      <td>
                        <span v-if="item.driverName">{{
                          item.driverName
                        }}</span>
                        <span v-else>-</span>
                      </td>
                      <td v-if="type !== 'view'">
                        <el-button type="text" @click="deleteFn(index)">删除</el-button>
                        <el-tooltip content="下移" placement="top" v-if="index !==
                          form.vehicleJson[dateActiveIndex].vehicleInfo
                            .length -
                          1
                          " class="move-arrow">
                          <i class="iconfont icon-move-down" @click="moveClick(index, 'down')"></i>
                        </el-tooltip>
                        <el-tooltip content="上移" placement="top" v-if="index !== 0" class="move-arrow">
                          <i class="iconfont icon-move-up" @click="moveClick(index, 'up')"></i>
                        </el-tooltip>
                      </td>
                    </tr>
                  </table>

                  <!--如果日期为当天，或当前为查看页，或班次条数已经15条，则隐藏【添加车辆】-->
                  <div class="add" @click="handleAdd" v-if="form.vehicleJson &&
                    form.vehicleJson.length < 100 &&
                    type !== 'view'
                    ">
                    <i class="el-icon-plus"></i>添加车辆
                  </div>
                </div>
              </div>
            </div>
          </el-form>
        </template>

        <scheduling-vehicle @confirm="vehicleConfirm" :line="info" :scheduling="dialogScheduling"
          :multiple="info.schedulingType === 2" :drivers.sync="dialogDrivers" :visible.sync="schedulingVehicleState"
          :lineOId="lineOId">
        </scheduling-vehicle>
      </el-tab-pane>
      <el-tab-pane label="司机创建" name="driver">
        <div class="schedulingFormTop">
          <div class="line-info schedulingFormTopItem" :class="info.schedulingType === 2 ? '' : 'schedulingFormTopItemLine'
            ">
            <img class="icon-line" src="../../../assets/img/line.png" alt="" />
            <span style="font-weight: 600">{{ info.startStationName }} - {{ info.endStationName }}</span>

            <div style="display: flex; height: 28px; margin: 0 30px">
              <span v-if="info.schedulingType == 1 ||
                info.schedulingType == 3 ||
                info.schedulingType == 2
                ">{{ info.schedulingType | filterConst("SCHELINGTYPE") }}
              </span>
            </div>

            <div v-if="info.railType !== 2 &&
              (info.schedulingType === 1 || info.schedulingType == 2)
              ">
              票价:<span style="color: rgb(255, 153, 0)">{{
                info.fee == null ? "待设置" : "¥" + info.fee
              }}</span>
            </div>
          </div>
        </div>
        <template v-if="info.schedulingType === 1 ||
            info.schedulingType === 2 ||
            info.schedulingType === 3
            ">
          <el-form :model="formDriver" ref="formDriver" label-width="0">
            <div class="sF-item" :class="info.schedulingType === 2 ? '' : 'sF-item-line'">
              <div class="sF-cont">
                <div class="scheduling-form-date">
                  <div class="left">
                    <custom-across-roll ref="customAcrossRoll2">
                      <div class="date" :class="dateActiveDriverIndex === i ? 'active' : ''"
                        @click="dateDriverClick(scheduling, i)" v-for="(scheduling, i) in schedulingDriverJson" :key="i">
                        <span class="date-text">{{ getWeek(scheduling.schedulingTime) }}
                          {{
                            scheduling.schedulingTime | filterTime("MM-DD")
                          }}</span>
                      </div>
                    </custom-across-roll>
                  </div>
                </div>

                <div style="display: flex; align-items: center; margin: 20px 0">
                  <strong style="margin-right: 20px">状态：</strong>
                  <el-radio-group v-model="status" @change="statusChange" style="margin-right: 50px">
                    <el-radio :label="1">全部</el-radio>
                    <el-radio :label="2">停止售票</el-radio>
                    <el-radio :label="3">售票中</el-radio>
                  </el-radio-group>

                  <el-checkbox v-model="checked" @change="statusChange">只看有余票</el-checkbox>
                </div>

                <div class="scheduling-form-table">
                  <table border class="table table_scheduling">
                    <tr>
                      <th class="th1">状态</th>
                      <th class="th2">
                        开始{{
                          info.lineType == 1 || info.lineType == 2
                          ? "检票"
                          : "接人"
                        }}
                      </th>
                      <th class="th3">预计发车</th>
                      <th class="th4" v-if="info.schedulingType === 1 || info.schedulingType === 3
                          ">
                        值班车辆
                      </th>
                      <th class="th5" v-if="info.schedulingType === 1 || info.schedulingType === 3
                        ">
                        可购票
                      </th>
                      <th class="th7">已购票</th>
                      <th class="th8">余票</th>
                      <th class="th9">是否启用</th>
                    </tr>
                    <tr v-if="!formDriver.shiftActive ||
                      formDriver.shiftActive.length == 0
                      ">
                      <td colspan="8" style="text-align: center">暂无数据</td>
                    </tr>
                    <tr @click="According(item)" :class="item.soldTickets <= 0 ? '' : 'gray'"
                      v-for="(item, index) in formDriver.shiftActive" :key="index">
                      <template v-if="item.show">
                        <td class="th1">
                          <span v-if="item.status === 1 && item.isEnabled == 1">售票中</span>
                          <span v-if="item.status === 2 || item.isEnabled == 2">停止售票</span>
                        </td>
                        <td class="th2">
                          {{ item.startTime }}
                        </td>
                        <td class="th3">
                          {{ item.endTime }}
                        </td>
                        <td class="th4" v-if="info.schedulingType === 1 ||
                          info.schedulingType === 3
                          ">
                          <template v-if="item.schedulingVehicleJson &&
                            item.schedulingVehicleJson.length > 0
                            ">
                            <p v-for="vehicleObj in item.schedulingVehicleJson" :key="vehicleObj.id">
                              <span :class="type == 'view' ? 'link' : ''">{{
                                vehicleObj.licenseNo
                              }}</span>
                              {{ vehicleObj.vehicleSeat }}座
                              {{ vehicleObj.driverName }}
                            </p>
                          </template>
                          <span v-else style="color: #999">待添加</span>
                        </td>
                        <td class="th5" v-if="info.schedulingType === 1 ||
                          info.schedulingType === 3
                          ">
                          <span v-if="item.ticketNum">{{ item.ticketNum }}张</span>
                          <span v-else>-</span>
                        </td>
                        <td class="th7">
                          {{
                            item.soldTickets || item.soldTickets === 0
                            ? item.soldTickets
                            : "-"
                          }}
                        </td>
                        <td class="th8">
                          {{
                            item.remainingTickets
                            ? item.remainingTickets
                            : item.ticketNumType === 1
                              ? "-"
                              : item.compile
                                ? "-"
                                : 0
                          }}
                        </td>
                        <td class="th9">
                          <div class="custom-switch">
                            <el-switch v-model="item.isEnabled" :active-value="1" :inactive-value="2"
                              @change="switchClick($event, item)">
                            </el-switch>
                          </div>
                        </td>
                      </template>
                    </tr>
                  </table>
                </div>

                <el-button style="margin-top: 40px; width: 120px" plain v-if="info.railType == 2" @click="showLine">
                  查看线路票价
                </el-button>
              </div>
            </div>
          </el-form>
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import customAcrossRoll from "../../../components/custom-across-roll";
import schedulingVehicle from "./schedulingVehicle";
export default {
  name: "schedulingForm",
  components: {
    customAcrossRoll,
    schedulingVehicle,
  },
  watch: {
    "form.shiftActive"(item) {
      this.lastListArr = [];
      for (let i of item) {
        if (i.operationType !== 3) {
          this.lastListArr.push(i);
        }
      }
    },
  },
  data() {
    return {
      tabAction: "platform",
      detailTitle: "线路票价",
      buyBool: false,
      showEdit: false, //显示编辑框
      //票价
      input2: "",
      lastListArr: [],
      //模态框
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogIndex: [],
      dialogDrivers: [],
      dialogScheduling: {},
      schedulingVehicleState: false,
      today: new Date().setHours(23, 59, 59, 0) / 1000,
      // 页面状态
      type: this.$route.query.type,
      // 线路id
      lineId: this.$route.query.id,
      //设置价格按钮
      BtnSucc: true,
      // 日期列表
      dateList: [],
      // 表单对象
      form: {
        // 当前选中的
        shiftActive: [],
        vehicleJson: [],
      },
      formDriver: {
        // 当前选中的
        shiftActive: [],
        vehicleJson: [],
      },
      // 线路详情信息
      info: {},
      //线路详情数据
      priceForm: {
        stationRailFee: [],
      },

      // 加载中
      loading: false,
      /** 数据
         schedulingJson: [
         {
                schedulingTime: "排班时间10位时间戳",
                shift:[
                  {
                    operationType:'操作类型1-新增，2-编辑，3-删除',
                    status: "状态",
                    startTime: "时:分字符串",
                    endTime: "时:分字符串",
                    ticketNumType: "票数限制1.不限购2.限购",
                    ticketNum: "票数",
                    soldTickets:'已购票数'
                  },
                  {
                    operationType:'操作类型1-新增，2-编辑，3-删除',
                    status: "状态",
                    startTime: "时:分字符串",
                    endTime: "时:分字符串",
                    ticketNumType: "票数限制1.不限购2.限购",
                    ticketNum: "票数",
                    soldTickets:'已购票数'
                  }
                ]
              }
         ] */
      schedulingJson: [],
      // 选中的日期索引
      dateActiveIndex: 0,
      //点击查看座位数据
      Accordinsg: [],
      // 司机排版
      schedulingDriverJson: [],
      dateActiveDriverIndex: 0,
      buyNum: false,
      status: 1,
      checked: false,
      newCopy: null,
      lineOId: "",
    };
  },
  computed: {
    getVehicles() {
      return this.form.vehicleJson[this.dateActiveIndex]?.vehicleInfo || [];
    },
  },
  methods: {
    // 上下移动
    moveClick(idx, type) {
      const vehicles = this.form.vehicleJson[this.dateActiveIndex].vehicleInfo;
      const curr = vehicles[idx];
      if (type === "down") {
        const next = vehicles[idx + 1];
        const _sort = curr.sort;
        curr.sort = next.sort;
        next.sort = _sort;
        this.$set(vehicles, idx, next);
        this.$set(vehicles, idx + 1, curr);
      } else if (type === "up") {
        const last = vehicles[idx - 1];
        const _sort = curr.sort;
        curr.sort = last.sort;
        last.sort = _sort;
        this.$set(vehicles, idx, last);
        this.$set(vehicles, idx - 1, curr);
      }
    },
    //查看路线详情
    async showLine() {
      this.dialogVisible3 = true;
      this.showEdit = false;
      let url = "/api/v1/manage/line/stationRail/" + this.lineId;
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.priceForm.stationRailFee = data.data;
        this.getTickets();
      }
    },
    //是否购票
    async getTickets() {
      this.dialogVisible3 = true;
      this.showEdit = false;
      let url = "/api/v1/manage/line/queryIsSoldTicketsByLineId/" + this.lineId;
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.buyBool = data.data;
        // this.priceForm.stationRailFee = data.data;
      }
    },
    //点击查看显示座位
    async According(item) {
      this.Accordinsg = [];
      if (this.type === "view" && this.info.schedulingType === 3) {
        this.dialogVisible2 = true;
        let url = "/api/v1/manage/line/vehicle/seatNoAndFee";

        let params = {
          schedulingId: item.schedulingVehicleJson[0].schedulingId,
          vehicleId: item.schedulingVehicleJson[0].vehicleId,
        };
        let data = await this.$axios.get(url, params);
        if (data && data.code === 1) {
          data.data.forEach((item) => {
            item.seatNo = item.seatNo.substring(0, 1);
          });
          this.Accordinsg = data.data;
        }
      }
    },
    handleAdd() {
      this.schedulingVehicleState = true;
      if (this.form.vehicleJson[this.dateActiveIndex]) {
        this.dialogDrivers =
          this.form.vehicleJson[this.dateActiveIndex].vehicleInfo;
      } else {
        this.form.vehicleJson[this.dateActiveIndex] = {
          schedulingTime:
            this.schedulingJson[this.dateActiveIndex].schedulingTime,
        };
      }
      this.$forceUpdate();
    },
    //模态框
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => { });
    },
    /**
     * 开关
     */
    switchClick(isEnabled, row) {
      let params = {
        isEnabled: row.isEnabled,
        schedulingId: row.id,
      };
      if (isEnabled == 1) {
        this.$confirm("确认启用该班次吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "success",
        })
          .then(() => {
            this.postSwitch(params, isEnabled, row);
          })
          .catch(() => {
            row.isEnabled = 2;
          });
      } else {
        this.$confirm("停止该班次后，乘客将无法购票，确认这样做吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.postSwitch(params, isEnabled, row);
          })
          .catch(() => {
            row.isEnabled = 1;
          });
      }
    },
    postSwitch(params, isEnabled, row) {
      let url = "/api/v1/manage/line/scheduling/isEnabled";
      this.$axios
        .post(url, params)
        .then((data) => {
          if (data && data.code === 1) {
            if (isEnabled == 1) {
              this.$message({
                type: "success",
                message: "启用成功",
              });
            } else {
              this.$message({
                type: "success",
                message: "已禁用!",
              });
            }
            this.getInfo();
            this.getInfoDriver();
          } else {
            row.isEnabled = row.isEnabled == 1 ? 2 : 1;
          }
        })
        .catch((err) => {
          row.isEnabled = row.isEnabled == 1 ? 2 : 1;
        });
    },
    // 修改排班模式
    async postSchedulingType(schedulingType) {
      let url = "/api/v1/manage/line/schedulingType";
      let params = {
        lineId: this.lineId,
        schedulingType,
      };
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.getInfo();
      }
    },
    getWeek(timestamp) {
      let date = new Date(timestamp * 1000);
      var week;
      if (date.getDay() == 0) week = "周日";
      if (date.getDay() == 1) week = "周一";
      if (date.getDay() == 2) week = "周二";
      if (date.getDay() == 3) week = "周三";
      if (date.getDay() == 4) week = "周四";
      if (date.getDay() == 5) week = "周五";
      if (date.getDay() == 6) week = "周六";
      return week;
    },
    //删除班次
    removeFn(item, index) {
      // version:已保存过的班次
      if (item.version) {
        this.form.shiftActive = this.form.shiftActive.map((item, i) => {
          if (i === index) {
            item.operationType = 3;
          }
          return item;
        });
      } else {
        this.form.shiftActive.splice(index, 1);
      }
    },

    deleteFn(index) {
      this.$confirm(`确认要在本线路中，移除该车辆吗？`, "提示").then(() => {
        const delVehicle = this.form.vehicleJson[
          this.dateActiveIndex
        ].vehicleInfo.splice(index, 1);
        let _sort = delVehicle[0].sort;
        for (
          let j = index;
          j <
          this.form.vehicleJson[this.dateActiveIndex].vehicleInfo.length - 1;
          j++
        ) {
          let sort_ =
            this.form.vehicleJson[this.dateActiveIndex].vehicleInfo[j].sort;
          this.form.vehicleJson[this.dateActiveIndex].vehicleInfo[j].sort =
            _sort;
          _sort = sort_;
        }
      });
    },
    schedulingVehicleConfirm(row) {
      this.form.vehicleJson.push(row);
    },
    /**
     * 开始时间验证器
     */
    validate(rule, value, callback) {
      let arr = rule.fullField.split(".");
      let i = Number(arr[1]);
      let item = this.form.shiftActive[i].startTime;
      let prevItem =
        i > 0 && this.form.shiftActive[i - 1].operationType !== 3
          ? this.form.shiftActive[i - 1].startTime
          : null;
      let nextItem =
        this.form.shiftActive[i + 1] &&
          this.form.shiftActive[i + 1].operationType !== 3
          ? this.form.shiftActive[i + 1].startTime
          : null;
      if (!value) {
        callback(new Error("开始时间不能为空"));
      } else if (i > 0 && prevItem && item < prevItem) {
        callback(new Error("不能小于上一个班次的开始检票/接人时间"));
      } else if (i < 15 && nextItem && item > nextItem) {
        callback(new Error("不能大于下一个班次的开始时间"));
      } else {
        callback();
      }
    },
    /**
     * 预计发车验证器
     */
    validateEnd(rule, value, callback) {
      let arr = rule.fullField.split(".");
      let i = Number(arr[1]);
      let item = this.form.shiftActive[i].endTime;
      let startItem = this.form.shiftActive[i].startTime;
      if (!value) {
        callback(new Error("发车时间不能为空"));
      } else if (item < startItem) {
        callback(new Error("不能小于开始时间"));
      } else {
        callback();
      }
    },
    /**
     * 鼠标悬浮
     */
    async dateHover(type, i) {
      let obj = new Object(this.schedulingJson[i]);
      if (type === "over" && obj.remove) {
        this.schedulingJson[i].remove = 1;
      }
      if (type === "out" && obj.remove) {
        this.schedulingJson[i].remove = 2;
      }
    },
    /**
     * 点击日期按钮
     */
    async dateClick(item, i) {
      this.newCopy = null;
      this.dateActiveIndex = i;
      this.form.shiftActive = item.shift;
    },
    /**
     * 点击司机排班日期按钮
     */
    async dateDriverClick(item, i) {
      this.dateActiveDriverIndex = i;
      this.formDriver.shiftActive = item.shift;
    },

    /**
     * 复制排班
     */
    copyClick() {
      let last = JSON.parse(
        JSON.stringify(this.schedulingJson[this.schedulingJson.length - 1])
      );
      let shift = [];
      last.shift.map((item) => {
        if (!item.operationType || item.operationType != 3) {
          let schedulingVehicleJson = [];
          if (item.schedulingVehicleJson) {
            schedulingVehicleJson = item.schedulingVehicleJson.map((banci) => {
              if (banci.vehicleSeatAndFeeVos) {
                banci.vehicleSeatAndFeeVos = banci.vehicleSeatAndFeeVos.map(
                  (zuowei) => {
                    zuowei.id = null;
                    return zuowei;
                  }
                );
              }
              return banci;
            });
          }

          shift.push({
            id: null,
            status: 1,
            isEnabled: 1,
            schedulingVehicleJson: schedulingVehicleJson,
            startTime: item.startTime,
            endTime: item.endTime,
            ticketNumType: item.ticketNumType,
            soldTickets: "",
            ticketNum: item.ticketNum,
            compile: true, // 是否可以编辑
            show: true,
          });
        }
      });
      let obj = {
        remove: 2, // 控制日期是否可被可被移除, 1-可以移除，显示，2-可以移除，不显示，其他-不可移除
        schedulingTime: last.schedulingTime + 24 * 60 * 60,
        shift,
        isNew: true, // 是不是新增的日期
      };
      this.newCopy = last.schedulingTime + 24 * 60 * 60;

      this.schedulingJson.push(obj);

      // Copy对应日期车辆
      const _lastVehicle =
        this.form.vehicleJson[this.form.vehicleJson.length - 1];

      const lastVehicle = _lastVehicle
        ? JSON.parse(JSON.stringify(_lastVehicle))
        : { vehicleInfo: [], schedulingTime: "" };
      lastVehicle.schedulingTime = this.newCopy;

      this.form.vehicleJson.push(lastVehicle);

      // 点击添加日期按钮时调用子组件判断是否需要显示左右箭头，并将日期组件移动至末尾
      this.$refs.customAcrossRoll.isShow();
      this.$refs.customAcrossRoll.navNext();
    },

    /**
     * 点击日期按钮上的×
     */
    async removeClick(scheduling, i) {
      let date = this.$utils.timeFn(
        this.schedulingJson[i].schedulingTime,
        "MM-DD"
      );
      if (scheduling.isNew) {
        this.$confirm(`确认删除该日期(${date})吗？`, "删除提示").then(() => {
          //  日期补位
          this.schedulingJson.forEach((item, index) => {
            if (index >= i) {
              item.schedulingTime = item.schedulingTime - 24 * 60 * 60;
            }
          });

          this.schedulingJson.splice(i, 1);
          if (i === this.schedulingJson.length) {
            this.dateActiveIndex = this.schedulingJson.length - 1;
          } else if (i < this.dateActiveIndex && i > 0) {
            this.dateActiveIndex = this.dateActiveIndex - 1;
          }
          this.form.shiftActive =
            this.schedulingJson[this.dateActiveIndex].shift;
          const delVehicle = this.form.vehicleJson.splice(i, 1);
        });
      } else {
        if (scheduling.sum > 0) {
          this.$alert(`该日期(${date})下已有乘客购票，无法被删除！`, "提示");
          return;
        }
        this.$confirm(`确认删除该日期(${date})下全部班次吗？`, "删除提示").then(
          () => {
            this.schedulingJson.map((item, index) => {
              if (index === i && item.shift && item.shift.length > 0) {
                let newShift = [];
                for (let shift of item.shift) {
                  shift.operationType = 3;
                  // version:已保存过的班次
                  if (shift.version) {
                    newShift.push(shift);
                  }
                }
                item.shift = newShift;
              }

              return item;
            });
            this.form.vehicleJson.splice(i, 1);
          }
        );
      }
    },

    /**
     * 点击添加日期按钮
     */
    async addDateClick() {
      let last = this.schedulingJson[this.schedulingJson.length - 1];
      let obj = {
        remove: 2, // 控制日期是否可被可被移除, 1-可以移除，显示，2-可以移除，不显示，其他-不可移除
        schedulingTime: last.schedulingTime + 24 * 60 * 60,
        shift: [],
        isNew: true, // 是不是新增的时间
      };
      this.schedulingJson.push(obj);
      // 点击添加日期按钮时调用子组件判断是否需要显示左右箭头，并将日期组件移动至末尾
      this.$refs.customAcrossRoll.isShow();
      this.$refs.customAcrossRoll.navNext();
    },

    async queryIsSoldTickets(schedulingId) {
      if (!schedulingId) {
        return false;
      } else {
        let url = "/api/v1/manage/line/queryIsSoldTickets/" + schedulingId;
        let data = await this.$axios.get(url);
        if (data && data.code === 1) {
          return data.data;
        } else {
          return false;
        }
      }
    },

    async editVehicle(item, index) {
      let state = await this.queryIsSoldTickets(item.id);
      if (state) {
        this.$message.warning("该班次已有乘客购票，无法编辑车辆");
        this.refresh(this.info.schedulingType);
      } else {
        this.schedulingVehicleState = true;
        this.dialogDrivers = item.schedulingVehicleJson || [];

        this.dialogIndex = index;
        this.dialogScheduling = item;
        this.dialogScheduling.schedulingTime =
          this.schedulingJson[this.dateActiveIndex].schedulingTime;
      }
    },

    vehicleConfirm(result) {
      if (this.info.schedulingType === 1 || this.info.schedulingType === 3) {
        let ticketNum = result.reduce((a, b) => a + (b.vehicleSeat - 1), 0);
        this.form.shiftActive[this.dialogIndex].ticketNum = ticketNum;
        this.form.shiftActive[this.dialogIndex].operationType = 2;
        if (result[0].vehicleSeatAndFeeVos) {
          result[0].vehicleSeatAndFeeVos = result[0].vehicleSeatAndFeeVos.map(
            (item) => {
              item.id = null;
              return item;
            }
          );
        }

        this.form.shiftActive[this.dialogIndex].schedulingVehicleJson = result;
      } else {
        const time = this.schedulingJson[this.dateActiveIndex].schedulingTime;
        const target = this.form.vehicleJson.find(
          (item) => item.schedulingTime === time
        );
        const vehicles = result.map((item, idx) => {
          return {
            ...item,
            sort: idx + 1,
            licenseNo: item.licenseNo,
            vehicleId: item.vehicleId,
            driverId: item.driverId,
          };
        });
        if (target) {
          target.vehicleInfo = vehicles;
          this.$set(this.form.vehicleJson, this.dateActiveIndex, target);
        } else {
          this.form.vehicleJson.push({
            schedulingTime: time,
            vehicleInfo: vehicles,
          });
        }
      }
    },

    /**
     * 点击添加班次按钮
     */
    addClick(index) {
      let obj = {
        status: 1,
        startTime: "",
        endTime: "",
        ticketNumType: 1,
        soldTickets: "",
        ticketNum: "",
        isEnabled: 1,
        compile: true, // 是否可以编辑
        show: true,
        addStatus: true,
      };
      if (this.info.schedulingType === 1 || this.info.schedulingType === 3) {
        // obj.schedulingVehicleJson = [];
        obj.ticketNumType = 2;
      }
      if (typeof index == "number") {
        // 插班
        this.form.shiftActive.splice(index, 0, obj);
      } else {
        // 添加
        this.form.shiftActive.push(obj);
      }

      this.schedulingJson[this.dateActiveIndex].shift = this.form.shiftActive;
    },

    /**
     * 变化
     */
    changeFn(index, item) {
      this.schedulingJson[this.dateActiveIndex].shift[index].operationType = 2;
      if (item) {
        item.ticketNumType === 1 ? (item.ticketNum = "") : "";
      }
    },

    async resetVerify() {
      let params = {
        lineId: this.lineId,
      };
      let url = "/api/v1/manage/line/reset/verify";
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        return data.data;
      }
    },

    //格式重置
    async reset() {
      let state = await this.resetVerify();
      if (!state) {
        this.$message.warning("有班次已购票，无法重置");
      } else {
        this.$confirm(
          "重置后会清空所有班次，重新选择排班模式，确定这样做吗？",
          "提示"
        ).then(async () => {
          let params = {
            lineId: this.lineId,
          };
          let url = "/api/v1/manage/line/reset";
          let data = await this.$axios.post(url, params);
          if (data && data.code === 1) {
            this.refresh();
          }
        });
      }
    },

    refresh(schedulingType) {
      this.dateActiveIndex = 0;
      this.schedulingJson = [];
      this.form = {
        shiftActive: [],
        vehicleJson: [],
      };
      this.info.fee = null;
      this.info = {
        schedulingType,
      };

      this.dateActiveDriverIndex = 0;
      this.schedulingDriverJson = [];
      this.formDriver = {
        shiftActive: [],
        vehicleJson: [],
      };

      this.getInfo();
      this.getInfoDriver();
    },

    /**
     * 点击保存
     */
    async saveClick() {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          let item = this.schedulingJson.find(
            (value) => value.isNew && (!value.shift || value.shift.length === 0)
          );
          if (item) {
            let date = this.$utils.timeFn(item.schedulingTime, "MM-DD");
            this.$message.warning(`【${date}】未添加任何班次！`);
            return false;
          }
          if (
            this.info.schedulingType === 1 ||
            this.info.schedulingType === 2
          ) {
            if (this.info.fee === null || this.info.fee === 0) {
              this.$message.warning(
                `该线路价格异常无法排班，请删除线路后重新添加`
              );
              return false;
            }
          }

          this.postFn();
        } else {
          let arr = Object.keys(object);
          let dateIndex = Number(arr[0].split(".")[1]) + 1;
          this.$message.warning(`请检查第【${dateIndex}】条数据输入是否正确！`);
          return false;
        }
      });
    },

    /**
     * 接口调用-保存排班信息
     */
    async postFn() {
      this.loading = true;
      let url = "/api/v1/manage/line/scheduling";
      const vehicleJSON = this.form.vehicleJson.map((item) => {
        return {
          schedulingTime: item.schedulingTime,
          vehicleInfo: item.vehicleInfo.map((item) => {
            return {
              sort: item.sort,
              licenseNo: item.licenseNo,
              vehicleId: item.vehicleId,
              driverId: item.driverId,
            };
          }),
        };
      });
      let params = {
        lineId: this.lineId,
        schedulingJson: JSON.stringify(this.schedulingJson),
        vehicleJson: JSON.stringify(vehicleJSON),
        // this.form.vehicleJson && this.form.vehicleJson.length > 0
        //   ? this.form.vehicleJson.map((item) => item.id).join()
        //   : "",
      };
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.$router.push({
          path: "/scheduling",
          query: { id: data.data },
        });
      }
      this.loading = false;
    },

    // 状态筛选
    statusChange() {
      this.form.shiftActive.forEach((item) => {
        if (this.status == 1) {
          item.show = true;
        } else if (this.status == 2) {
          item.show = item.status == 2 || item.isEnabled == 2;
        } else if (this.status == 3) {
          item.show = item.status === 1 && item.isEnabled == 1;
        }
        if (this.checked && item.show) {
          item.show = item.remainingTickets > 0 || item.ticketNumType == 1;
        }
      });

      this.formDriver.shiftActive.forEach((item) => {
        if (this.status == 1) {
          item.show = true;
        } else if (this.status == 2) {
          item.show = item.status == 2 || item.isEnabled == 2;
        } else if (this.status == 3) {
          item.show = item.status === 1 && item.isEnabled == 1;
        }
        if (this.checked && item.show) {
          item.show = item.remainingTickets > 0 || item.ticketNumType == 1;
        }
      });
    },
    /**
     * 接口调用-获取平台排班信息
     */
    async getInfo() {
      let url = "/api/v1/manage/line/scheduling/" + this.lineId;
      let params = {
        channel: 1,
      };
      let data = await this.$axios.get(url, params);
      if (data?.code === 1) {
        this.lineOId = data.data?.line?.organizationId;
        this.schedulingJson = [];
        if (data.data?.line?.schedulingType) {
          if (data.data.scheduling?.length > 0) {
            let currentList = [];
            // 日期补0
            let minTime = new Date().setHours(0, 0, 0, 0) / 1000; // 当天0点
            let lastTime =
              data.data.scheduling[data.data.scheduling.length - 1]
                .schedulingTime;
            if (
              lastTime - minTime &&
              (lastTime - minTime) / 86400 + 1 !== data.data.scheduling.length
            ) {
              // 缺少日期
              for (let i = 0; i < (lastTime - minTime) / 86400 + 1; i++) {
                let item = data.data.scheduling.find(
                  (item) => item.schedulingTime === minTime + 86400 * i
                );
                if (item) {
                  let sum = 0;
                  if (item.shift && item.shift.length > 0) {
                    sum = item.shift.reduce(function (prev, cur) {
                      return Number(cur.soldTickets) + prev;
                    }, 0);
                  }
                  item.remove = 2;
                  item.sum = sum;
                  currentList.push(item);
                } else {
                  currentList.push({
                    schedulingTime: minTime + 86400 * i,
                    shift: [],
                    remove: 2, // 控制日期是否可被可被移除, 1-可以移除，显示，2-可以移除，不显示，其他-不可移除
                  });
                }
              }
            } else {
              currentList = data.data.scheduling.map((item) => {
                let sum = 0;
                if (item.shift && item.shift.length > 0) {
                  sum = item.shift.reduce(function (prev, cur) {
                    return cur.soldTickets + prev;
                  }, 0);
                }
                item.remove = 2;
                item.sum = sum;
                return item;
              });
            }
            let buyNum = 0;
            currentList.map((row) => {
              if (row.shift && row.shift.length > 0) {
                row.shift.forEach((item) => {
                  item.show = true;
                  buyNum += item.soldTickets;
                });
              }
              row;
            });
            const t1 = data.data.lineVehicleList
              ? data.data.lineVehicleList.map((item) => item.schedulingTime)
              : [];
            const t2 = data.data.scheduling
              ? data.data.scheduling.map((item) => item.schedulingTime)
              : [];
            const t = Array.from(new Set([...t1, ...t2]));
            currentList.forEach((item) => {
              const target = t.find((_item) => _item === item.schedulingTime);
              // 判断是不是已有的数据
              if (target) {
                // 班次信息数据初始化
                this.schedulingJson.push(item);
                // 值班车辆信息数据初始化
                const line = data.data.lineVehicleList
                  ? data.data.lineVehicleList.find(
                    (item) => item.schedulingTime === target
                  )
                  : null;
                if (line) {
                  this.form.vehicleJson.push(line);
                } else {
                  this.form.vehicleJson.push({
                    schedulingTime: item.schedulingTime,
                    vehicleInfo: [],
                  });
                }
              } else {
                // 这里是前端自动添加的数据
                // 班次信息数据初始化
                this.schedulingJson.push({
                  schedulingTime: item.schedulingTime,
                  shift: [],
                  remove: 2,
                });
                // 值班车辆信息数据初始化
                this.form.vehicleJson.push({
                  schedulingTime: item.schedulingTime,
                  vehicleInfo: [],
                });
              }
            });
            this.form.shiftActive =
              currentList && currentList.length > 0
                ? currentList[this.dateActiveIndex].shift
                : null;
          } else if (data.data.lineVehicleList?.length) {
            const t1 = data.data.lineVehicleList
              ? data.data.lineVehicleList.map((item) => item.schedulingTime)
              : [];
            const t2 = data.data.scheduling
              ? data.data.scheduling.map((item) => item.schedulingTime)
              : [];
            const t = Array.from(new Set([...t1, ...t2]));
            const vehicleList = data.data.lineVehicleList || [];
            vehicleList.forEach((item) => {
              const target = t.find((_item) => _item === item.schedulingTime);
              // 判断是不是已有的数据
              if (target) {
                // 班次信息数据初始化
                this.schedulingJson.push(item);
                // 值班车辆信息数据初始化
                const line = data.data.lineVehicleList
                  ? data.data.lineVehicleList.find(
                    (item) => item.schedulingTime === target
                  )
                  : null;
                if (line) {
                  this.form.vehicleJson.push(line);
                } else {
                  this.form.vehicleJson.push({
                    schedulingTime: item.schedulingTime,
                    vehicleInfo: [],
                  });
                }
              } else {
                // 班次信息数据初始化
                this.schedulingJson.push({
                  schedulingTime: item.schedulingTime,
                  shift: [],
                  remove: 2,
                });
                // 值班车辆信息数据初始化
                this.form.vehicleJson.push({
                  schedulingTime: item.schedulingTime,
                  vehicleInfo: [],
                });
              }
            });
          } else if (this.type !== "view") {
            // 班次为空情况下
            let tomorrow = new Date().setHours(0, 0, 0, 0) / 1000; // 当天0点
            let obj = {
              schedulingTime: tomorrow,
              shift: [],
            };
            this.schedulingJson.push(obj);

            this.form.shiftActive = [];
            this.form.vehicleJson.push({
              schedulingTime: tomorrow,
              vehicleInfo: [],
            });
          }
          // 数据回显时调用子组件判断是否需要显示左右箭头
          this.$nextTick(() => {
            if (this.$refs.customAcrossRoll) {
              this.$refs.customAcrossRoll.isShow();
            }
          });
        }
        this.info = data.data.line || {};
      }
    },

    /**
     * 接口调用-获取该线路司机排班信息
     */
    async getInfoDriver() {
      let url = "/api/v1/manage/line/scheduling/" + this.lineId;
      let params = {
        channel: 2,
      };
      let data = await this.$axios.get(url, params);
      if (data?.code === 1) {
        if (data.data?.line?.schedulingType) {
          if (data.data.scheduling?.length > 0) {
            let currentList = data.data.scheduling;
            let buyNum = 0;
            currentList.map((row) => {
              if (row.shift && row.shift.length > 0) {
                row.shift.forEach((item) => {
                  item.show = true;
                  buyNum += item.soldTickets;
                });
              }
              row;
            });
            if (buyNum > 0) {
              this.buyNum = true;
            }
            this.schedulingDriverJson = data.data.scheduling;
            this.formDriver.shiftActive =
              data.data.scheduling && data.data.scheduling.length > 0
                ? data.data.scheduling[this.dateActiveIndex].shift
                : null;
          } else {
            this.schedulingDriverJson = [];
            this.formDriver.shiftActive = [];
          }
        }
      }
    },

    showMoatl() {
      if (this.buyNum) {
        this.$message({
          message: "无人购票的线路才能编辑",
          type: "error",
        });
        return;
      }
      this.input2 = this.info.fee;
      this.dialogVisible = true;
    },

    // 设置班车票价
    async feeSave() {
      if (this.input2 == 0) {
        this.$message({
          message: "票价不能为0元!",
          type: "error",
        });
        return false;
      }

      this.dialogVisible = false;
      let params = {
        lineId: this.lineId,
        fee: this.input2,
      };
      let url = "/api/v1/manage/line/saveLineFee";
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.info.fee = this.input2;
        this.input2 = "";
      }
    },

    // 保存时设置班车票价
    async feeSaves() {
      if (this.input2 == 0) {
        this.$message({
          message: "票价不能为0元!",
          type: "error",
        });
        return false;
      }

      this.dialogVisible = false;
      let params = {
        lineId: this.lineId,
        fee: this.input2,
      };
      let url = "/api/v1/manage/line/saveLineFee";
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.info.fee = this.input2;
        this.input2 = "";
        this.postFn();
      }
    },

    editFn() {
      if (!this.btnPreFn("scheduling_scheduling")) {
        return;
      }

      this.type = "";
    },

    handleEdit() {
      if (this.buyBool) {
        this.$message({
          message: "已有乘客购票，无法修改票价",
          type: "warning",
        });
      } else {
        this.detailTitle = "修改票价";
        this.showEdit = true;
      }
    },

    //修改线路价格
    async feeClick() {
      this.$refs.priceForm.validate((valid) => {
        if (valid) {
          let params = {};
          params.stationRailFee = JSON.stringify(this.priceForm.stationRailFee);
          this.updateRailFee(params);
        }
      });
    },

    //修改线路价格
    async updateRailFee(params) {
      let url = "/api/v1/manage/line/stationRail/updateRailFee";
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success("编辑成功！");
      }
      this.dialogVisible3 = false;
      this.detailTitle = "线路票价";
    },
  },
  created() {
    setTimeout(() => {
      this.info.schedulingType = this.$route.query.schedulingType;
    }, 1);
  },
  mounted() {
    this.getInfo();
    this.getInfoDriver();
    // 页面视口发生变化时调用子组件判断是否需要显示左右箭头
    this.$nextTick(() => {
      if (this.$refs.customAcrossRoll) {
        this.$refs.customAcrossRoll.isShow();
      }
    });
  },
};
</script>

<style lang="less" scoped>
#schedulingForm {
  /deep/ .schedulingFormTop {
    display: flex;
    align-items: center;

    .schedulingFormTopItem {
      width: 66%;
      height: 36px;
      padding-right: 16px;
    }

    .schedulingFormTopItem+.schedulingFormTopItem {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-left: 1px solid #ebebeb;
      padding-left: 16px;
      padding-right: 0;
    }

    .schedulingFormTopItemLine {
      width: 100%;
    }
  }

  .line-info {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
    color: #333333;

    .icon-line {
      width: 20px;
      margin-right: 8px;
      height: auto;
    }

    .icon-type {
      font-size: 16px;
      margin-left: 22px;
      font-weight: 500;
      line-height: 30px;
      border-radius: 4px;
      color: #409efc;
      padding: 2px 8px;
      background: rgba(64, 158, 252, 0.1);
    }

    .line-money {
      display: flex;
      align-items: center;
      background: #ffffff;
      box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.05);
      border-radius: 6px;
      height: 36px;
      padding: 0 12px;
      margin-left: 22px;

      img {
        width: 20px;
        height: auto;
        margin-right: 4px;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
      }
    }
  }

  .type-title {
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    color: #333333;
    opacity: 1;
    padding-top: 20px;
    padding-bottom: 16px;
  }

  .type-item {
    display: inline-block;
    box-shadow: 4px 4px 8px rgba(11, 121, 190, 0.2);
    border-radius: 24px;
    box-sizing: border-box;
    width: 279px;
    height: 317px;
    padding: 40px 32px;
    font-size: 22px;
    font-weight: 600;
    line-height: 30px;
    color: #ffffff;
    background: #409efc url("../../../assets/img/scheduing_bg1.png") no-repeat right bottom;
    background-size: 279px 317px;

    .des {
      width: 208px;
      font-size: 20px;
      font-weight: 500;
      margin: 20px 0 20px 0;
    }
  }

  .type-item+.type-item+.type-item {
    margin-left: 16px;
    box-shadow: 4px 4px 8px rgba(53, 54, 59, 0.2);
    background: #1cbc6c url("../../../assets/img/scheduing_bg2.png") no-repeat right bottom;
    background-size: 279px 317px;
  }

  .type-item+.type-item {
    margin-left: 16px;
    box-shadow: 4px 4px 8px rgba(53, 54, 59, 0.2);
    background: #35363b url("../../../assets/img/xuanzuo.png") no-repeat right bottom;
    background-size: 279px 317px;
  }

  /deep/ .el-dialog {
    .el-input-group__prepend {
      padding: 0 10px;
    }

    .el-input-group .el-input__inner {
      border-radius: 0px 4px 4px 0 !important;
      border-right: 1px solid #dcdfe6 !important;
    }
  }

  .el-form {
    display: flex;
  }

  .sF-item+.sF-item {
    border-left: 1px solid #ebebeb;
    padding-right: 0;
    padding-left: 16px;
    flex: 1;
  }

  .sF-item {
    width: 66%;
    padding-right: 16px;

    /*overflow-x: auto;*/
    /*padding-right: 16px;*/
    /*width: 50%;*/

    .sF-title {
      padding-bottom: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #ebebeb;
      font-size: 14px;
      font-weight: bold;

      .util-remark {
        font-weight: normal;
      }
    }

    .sF-cont {
      width: 100%;
    }
  }

  .sF-item-line {
    width: 100%;
  }

  .scheduling-form-top {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .info {
      display: flex;
      align-items: center;
      font-size: 14px;

      &>div {
        margin-right: 16px;
      }
    }
  }

  .remark {
    font-size: 14px;
    color: @color-danger;
    line-height: 28px;
    padding-left: 4px;
  }

  .date-box {
    width: calc(100% - 66px);

    .el-tabs__header {
      margin-bottom: 0;
    }

    .el-tabs--card>.el-tabs__header {
      border-bottom: none;
    }

    .el-tabs__item+.el-tabs__item {
      margin-left: 10px;
    }

    .el-tabs__item {
      padding: 0 8px;
      height: 28px;
      line-height: 28px;
      border: 1px solid #ebebeb;
      border-radius: 6px;

      &:hover {
        border-color: @color-primary;
        color: @color-primary;
      }
    }

    .el-tabs__item.is-active {
      border-color: @color-primary;
      background-color: @color-primary;
      color: #fff;
    }

    .el-tabs__nav-next,
    .el-tabs__nav-prev {
      position: absolute;
      cursor: pointer;
      line-height: 28px;
      font-size: 14px;
      color: #909399;
    }

    .el-tabs__item.is-active.is-closable .el-icon-close {
      width: 0;
    }
  }

  .scheduling-form-date {
    width: 100%;
    display: flex;
    align-items: center;
    margin: 12px 0;

    .left {
      width: 100%;
    }
  }

  .el-form {
    width: 100%;

    .el-form-item {
      margin-bottom: 0;
    }

    .el-input {
      min-width: 100px;
      width: 100%;
    }

    .ticket-num {
      width: 110px;

      /deep/ input {
        padding: 0 10px;
        text-align: center;
      }
    }
  }

  .add {
    margin-top: 12px;
    width: calc(100% - 2px);
    border: 1px #ebebeb dashed;
    line-height: 28px;
    text-align: center;
    cursor: pointer;

    &:hover {
      border-color: @color-primary;
      color: @color-primary;
    }
  }

  .scheduling-form-table {
    margin-top: 12px;
    /*height: 100%;*/
    /*overflow: auto;*/
    width: 100%;

    .el-input__inner {
      width: 100%;
    }

    .el-radio-group {
      display: flex;
      align-items: center;

      .el-input-group__append {
        padding: 0 6px;
      }
    }

    .table {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #ebeef5 !important;
      outline: none;

      th,
      td {
        height: 38px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        width: 130px;
        border-color: #ebeef5 !important;
        box-sizing: border-box;
        padding: 0 12px;
      }

      th {
        background-color: #fafafa;
        text-align: left;
      }

      .gray td {
        color: #999 !important;
      }
    }

    .table_scheduling {
      .el-button {
        margin-left: 0;
        margin-right: 10px;
      }

      .th1,
      .th5,
      .th7,
      .th8 {
        width: 80px;
      }

      .th6 {
        width: 120px;
      }

      .th4 {
        width: 160px;
        padding: 12px;
        line-height: 20px;
      }

      /*th:nth-child(1) {*/
      /*  width: 80px;*/
      /*}*/

      /*td:nth-child(1) {*/
      /*  width: 80px;*/
      /*}*/

      /*th:nth-child(6), th:nth-child(7) {*/
      /*  width: 60px;*/
      /*}*/

      /*td:nth-child(6), td:nth-child(7) {*/
      /*  width: 60px;*/
      /*}*/

      /*th:nth-child(7), td:nth-child(7) {*/
      /*  width: 120px;*/
      /*}*/

      /*th:nth-child(5), td:nth-child(5) {*/
      /*  width: 80px;*/
      /*}*/
    }

    .el-form-item__error {
      z-index: 10;
      white-space: nowrap;
    }
  }

  .motoal {
    text-align: center;
    margin-top: 20px;
  }

  // 禁用input的number箭头
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
}

.LookSeat {
  .seats-price {
    padding: 0 0 0 160px;
    box-sizing: border-box;
  }

  .seat-top {
    display: flex;
    justify-content: center;

    >div {
      display: flex;
      align-items: center;
    }

    .seat-top-left {
      margin-right: 40px;
    }

    .seat-top-right {
      margin-left: 20px;
    }

    .seat-top-span1 {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 6px;
      background: url("../../../assets/img/kexuan.png") no-repeat;
      background-size: 100% 100%;
    }

    .seat-top-span2 {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 6px;
      background: url("../../../assets/img/yixuan.png") no-repeat;
      background-size: 100% 100%;
    }
  }

  .seat-content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;

    .content-center {
      width: 40px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      color: #fff;
      font-weight: bold;
      position: relative;

      .seat-details {
        color: #409efc;
        position: absolute;
        top: -4px;
        left: 15px;
      }

      .seat-details1 {
        color: #fff;
        position: absolute;
        top: -4px;
        left: 15px;
      }
    }

    .driver {
      text-align: center;
      font-weight: bold;
      margin-left: 100px;
      margin-top: 10px;
    }

    .drivers {
      margin-bottom: 8px;
      width: 40px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background: url("../../../assets/img/siji.png");
      font-weight: bold;
    }
  }

  .passe1 {
    margin-top: 10px;

    >p {
      margin-top: 8px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }

    &:nth-child(2) {
      margin-left: 60px;
      margin-right: 60px;
    }

    &:nth-child(3) {
      margin-left: 70px;
    }

    &:nth-child(4) {
      margin-left: 50px;
    }

    &:nth-child(5) {
      margin-left: 40px;
    }
  }

  .passe2 {
    margin-top: 10px;

    >p {
      margin-top: 8px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }

    &:nth-child(2) {
      margin-left: 70px;
    }

    &:nth-child(3) {
      margin-left: 100px;
    }

    &:nth-child(4) {
      margin-left: 70px;
      margin-right: 20px;
    }

    &:nth-child(5) {
      margin-left: 70px;
    }

    &:nth-child(6) {
      margin-left: 45px;
    }

    &:nth-child(7) {
      margin-left: 45px;
    }
  }

  .passe3 {
    margin-top: 10px;

    >p {
      margin-top: 8px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }

    &:nth-child(2) {
      margin-left: 70px;
      margin-right: 70px;
    }

    &:nth-child(3) {
      margin-left: 70px;
    }

    &:nth-child(4) {
      margin-left: 45px;
    }

    &:nth-child(5) {
      margin-left: 45px;
    }

    &:nth-child(6) {
      margin-left: 70px;
    }

    &:nth-child(7) {
      margin-left: 45px;
    }

    &:nth-child(8) {
      margin-left: 45px;
    }
  }

  .passe4 {
    margin-top: 10px;

    >p {
      margin-top: 8px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }

    &:nth-child(2) {
      margin-left: 70px;
      margin-right: 0px;
    }

    &:nth-child(3) {
      margin-left: 100px;
    }

    &:nth-child(4) {
      margin-left: 70px;
    }

    &:nth-child(5) {
      margin-left: 100px;
    }

    &:nth-child(6) {
      margin-left: 70px;
    }

    &:nth-child(7) {
      margin-left: 78px;
    }

    &:nth-child(8) {
      margin-left: 40px;
    }

    &:nth-child(9) {
      margin-left: 40px;
    }
  }
}

.t {
  input {
    width: 70px;
  }
}

.el-dialog {
  .el-dialog__header {
    padding-bottom: 0;
  }

  .el-dialog__body {
    padding-top: 20px;
  }
}

.updatePrice {
  margin-top: -20px;
  margin-bottom: 20px;

  .detail {
    font-size: 17px;
    font-weight: bolder;
    padding-right: 10px;
  }

  .update {
    cursor: pointer;
    color: #0288ff;
  }
}

.submit {
  margin-top: 15px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    width: 100px;
    padding: 7px 15px;
  }
}

.move-arrow {
  color: #2b77ff;
  margin-left: 15px;
  cursor: pointer;
}
</style>
